var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M23 5.5a4.5 4.5 0 0 1-7.977 2.857l-5.15 2.575a4.5 4.5 0 0 1-.001 2.136l5.15 2.575a4.5 4.5 0 1 1-.895 1.788l-5.151-2.575a4.5 4.5 0 1 1 .003-5.713l5.149-2.575A4.5 4.5 0 1 1 23 5.5m-6.997 0a2.497 2.497 0 1 0 4.994 0 2.497 2.497 0 0 0-4.994 0m0 13a2.497 2.497 0 1 0 4.994 0 2.497 2.497 0 0 0-4.994 0M5.5 14.494a2.497 2.497 0 1 1 0-4.994 2.497 2.497 0 0 1 0 4.994",
    clipRule: "evenodd"
  })));
};
export default SvgShare;